import AiUsagesService from '../../services/AiUsagesService';
import aiUsagesUseCase from './aiUsagesUseCase';

const aiUsagesFactory = aiUsagesUseCase({
  AiUsagesService: AiUsagesService(),
});

export default aiUsagesFactory;
